import React, {useEffect} from "react";
import {matchPath} from "react-router";
import {Redirect, Route, Switch, useHistory, useLocation} from "react-router-dom";
import {routes} from "../../../../../core/models/static/routes/app-routes";
import NCRListView from "./list";
import NCRSingle from "./single";
import NCRNotes from "./notes";
import NCRTasks from "./tasks";
import NCRSettings from "./settings";
import useAccessLevels from "../../../../hooks/use-access-levels";

const NCRViews = () => {
    const location = useLocation();
    const history = useHistory();
    const operatorAccessLevels = useAccessLevels();


    /**
     * Listens for the changes in location and with each change:
     * if the url of the website is the same as the base url of the ncr, redirects to the list view of the ncr.
     */
    useEffect(() => {
        if (matchPath(location.pathname, {path: routes.ncr.base, exact: true})) {
            if (operatorAccessLevels.packages.ncr.viewList) {
                history.replace(routes.ncr.reports)
            } else if (operatorAccessLevels.packages.ncr.tasks && operatorAccessLevels.packages.taskNote.tasks) {
                history.replace(routes.ncr.tasks)
            } else if (operatorAccessLevels.packages.ncr.notes && operatorAccessLevels.packages.taskNote.notes) {
                history.replace(routes.ncr.notes)
            } else if (operatorAccessLevels.packages.ncr.editConfigurations) {
                history.replace(routes.ncr.settings)
            }
        }
    }, [history, location.pathname, operatorAccessLevels.packages.ncr.editConfigurations, operatorAccessLevels.packages.ncr.notes, operatorAccessLevels.packages.ncr.tasks, operatorAccessLevels.packages.ncr.viewList, operatorAccessLevels.packages.taskNote.notes, operatorAccessLevels.packages.taskNote.tasks])

    return (
        <>
            <Switch>
                <Route path={routes.operators.base} exact/>
                {
                    operatorAccessLevels.packages.ncr.viewList &&
                    <Route path={routes.ncr.reports} exact>
                        <NCRListView/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.ncr.viewDetails &&
                    <Route path={routes.ncr.single} exact>
                        <NCRSingle/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.ncr.tasks &&
                    operatorAccessLevels.packages.taskNote.tasks &&
                    <Route path={routes.ncr.tasks} exact>
                        <NCRTasks/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.ncr.notes &&
                    operatorAccessLevels.packages.taskNote.notes &&
                    <Route path={routes.ncr.notes} exact>
                        <NCRNotes/>
                    </Route>
                }
                {
                    operatorAccessLevels.packages.ncr.editConfigurations &&
                    <Route path={routes.ncr.settings} exact>
                        <NCRSettings/>
                    </Route>
                }
                <Redirect to={routes.ncr.base.concat(routes.error.accessDeniedForSection)}/>
            </Switch>
        </>
    );
};

export default NCRViews;
